import { Globe } from "@phosphor-icons/react";

export default function Logo({ size = 28, showText = true }) {
  return (
    <div className="flex items-center gap-2.5">
      <div
        className="relative rounded-lg p-1.5 flex items-center justify-center"
        style={{
          background: "linear-gradient(135deg, #1E40AF 0%, #2563EB 55%, #60A5FA 100%)",
          boxShadow: "0 0 24px rgba(59,130,246,0.35)",
        }}
      >
        <Globe size={size} weight="duotone" color="#F8FAFC" />
      </div>
      {showText && (
        <span
          className="text-xl font-semibold tracking-tight text-slate-50"
          style={{ fontFamily: "Outfit, sans-serif" }}
        >
          Nova
        </span>
      )}
    </div>
  );
}
